
import { defineComponent, reactive } from 'vue'

import Modal from '@/common/components/UI/Modal/index.vue'
import FileReader from '@/common/components/UI/FileReader/index.vue'

import { FTL } from '@/core/realisations/FTL.realisation'

import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'

import useNotifications from '@/common/composable/useNotifications'

export default defineComponent({
    components: {
        Modal,
        FileReader,
    },
    props: {
        ftlOrderId: {
            type: String,
            required: true,
        },
        invoiceNumber: {
            type: String,
            default: null,
        },
    },
    emits: ['cancel', 'submitted'],
    setup(props, { emit }) {
        const notifications = useNotifications()

        const state = reactive({
            is_loading: false,
            file: [] as File[],
        })

        const state_form$ = useVuelidate(
            {
                file: { required },
            },
            state
        )

        const emitCancel = () => {
            if (state.is_loading) return
            emit('cancel')
        }

        const emitSubmitted = async () => {
            if (state.is_loading) return

            state_form$.value.$touch()
            if (state_form$.value.$invalid) return

            try {
                state.is_loading = true

                const form_data = new FormData()
                form_data.append('file', state.file[0])

                await FTL.uploadFtlOrderScan(Number(props.ftlOrderId as string), form_data)

                notifications.notify({ title: 'Скан загружен', type: 'success' })
                emit('submitted')
            } catch (error) {
                console.error(error)
                notifications.notifyError({ error, title: 'При загрузке скана произошла ошибка' })
            } finally {
                state.is_loading = false
            }
        }

        return {
            state,
            state_form$,
            emitCancel,
            emitSubmitted,
        }
    },
})
